import React from 'react'
import { Button } from "@mui/material";
import { CANCEL_BUTTON } from 'store/constant';


const HDCancelButton = ({cancelButtonName, onHandleCancel, disableCancel }) => {
  return (
    <>
    <Button
          size="medium"
          variant="outlined"
          color="error"
          disabled={disableCancel}
          onClick={onHandleCancel}
          disableElevation
        >
          {cancelButtonName || CANCEL_BUTTON}
        </Button>
    </>
  )
}

export default HDCancelButton
